import React from "react";
import { useSelector } from "react-redux";
import { State } from "store";
import { THEME_LIGHT } from "store/userMeta";
import PolyIcon from "./PolyIcon";
import premiumBetaBadgeLight from "assets/images/premium_beta.svg";
import premiumBetaBadgeDark from "assets/images/premium_beta_alternate.svg";
import { FeatureFlagEnabled } from "./FeatureFlag";
import betaBadgeLight from "assets/images/beta.svg";
import betaBadgeDark from "assets/images/beta_alternate.svg";
import previewBadge from "assets/images/preview.svg";

export const PremiumBetaBadge: React.FC = () => {
  const theme = useSelector((state: State) => state.userMeta.theme);
  const badge =
    theme === THEME_LIGHT ? premiumBetaBadgeLight : premiumBetaBadgeDark;
  return (
    <img
      className="card-badge premium-beta ml-1"
      src={badge}
      alt="Premium Beta"
      data-testid="premium-beta-badge"
    />
  );
};

export const FeatureBadge: React.FC<{
  badge: {
    light: string;
    dark: string;
  };
  alt: string;
  testId: string;
  className?: string;
}> = ({ badge, alt, testId, className }) => {
  const theme = useSelector((state: State) => state.userMeta.theme);
  const img = theme === THEME_LIGHT ? badge.light : badge.dark;
  return (
    <img className={className ?? ""} src={img} alt={alt} data-testid={testId} />
  );
};

export const BetaBadge: React.FC<{
  className?: string;
}> = ({ className }) => (
  <FeatureBadge
    badge={{
      light: betaBadgeLight,
      dark: betaBadgeDark
    }}
    alt="Beta"
    testId="beta-badge"
    className={className}
  />
);

export const PreviewBadge: React.FC<{
  className?: string;
}> = ({ className }) => (
  <FeatureBadge
    badge={{
      light: previewBadge,
      dark: previewBadge
    }}
    alt="Preview"
    testId="preview-badge"
    className={className}
  />
);

export const PolyInternalBadge: React.FC = () => (
  <FeatureFlagEnabled feature="IS_POLY_USER">
    <div className="card-badge poly-internal d-flex">
      <PolyIcon icon="poly_propeller" className="mr-5" />
      POLY INTERNAL
    </div>
  </FeatureFlagEnabled>
);
